export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">精选优质内容，发现你感兴趣的精彩世界</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">

          {/* Card 1 */}
          <div className="group rounded-xl overflow-hidden border border-primary-400/40 bg-background-50 hover:border-primary-300/60 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20movie%20scene%20with%20warm%20golden%20lighting%2C%20film%20reel%20and%20popcorn%20on%20dark%20background%2C%20atmospheric%20theater%20vibe%2C%20rich%20contrast%2C%20editorial%20style%2C%20no%20text&width=640&height=400&seq=carousel-01&orientation=landscape"
                alt="热门大片"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center text-primary-500 bg-primary-100">
                  <i className="ri-movie-2-line text-sm"></i>
                </div>
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">最新上映院线同步</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">热门大片</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">好莱坞大片、华语新片第一时间上线，足不出户看遍全球热门电影，高清画质如临影院。</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group rounded-xl overflow-hidden border border-accent-400/40 bg-background-50 hover:border-accent-300/60 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vintage%20television%20set%20with%20warm%20glow%20in%20cozy%20dark%20room%2C%20nostalgic%20cinematic%20atmosphere%2C%20retro%20aesthetic%2C%20soft%20amber%20lighting%2C%20film%20grain%20texture%2C%20no%20text&width=640&height=400&seq=carousel-02&orientation=landscape"
                alt="经典剧集"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center text-accent-500 bg-accent-100">
                  <i className="ri-tv-2-line text-sm"></i>
                </div>
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">豆瓣高分口碑神剧</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">经典剧集</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">收录国内外高分电视剧全集，从《甄嬛传》到《权力的游戏》，经典永不褪色，随时重温。</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group rounded-xl overflow-hidden border border-secondary-400/40 bg-background-50 hover:border-secondary-300/60 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20abstract%20stage%20with%20spotlights%20and%20musical%20notes%2C%20vibrant%20concert%20atmosphere%2C%20dark%20background%20with%20neon%20pink%20and%20coral%20accents%2C%20energetic%20live%20show%20vibe%2C%20no%20text&width=640&height=400&seq=carousel-03&orientation=landscape"
                alt="热门综艺"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center text-secondary-500 bg-secondary-100">
                  <i className="ri-music-2-line text-sm"></i>
                </div>
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">全网热门真人秀合集</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">热门综艺</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">音乐竞演、户外挑战、恋爱观察……各类综艺一网打尽，周末放松追综的最佳伴侣。</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="group rounded-xl overflow-hidden border border-primary-400/40 bg-background-50 hover:border-primary-300/60 transition-all duration-300">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dreamy%20anime-style%20illustration%20with%20cherry%20blossoms%20and%20soft%20warm%20light%2C%20whimsical%20fantasy%20atmosphere%2C%20pastel%20coral%20and%20pink%20tones%20on%20dark%20background%2C%20Japanese%20animation%20aesthetic%2C%20no%20text&width=640&height=400&seq=carousel-04&orientation=landscape"
                alt="动漫番剧"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center text-primary-500 bg-primary-100">
                  <i className="ri-ghost-line text-sm"></i>
                </div>
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">日漫国漫同步追更</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">动漫番剧</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">热血、治愈、悬疑、搞笑——最新番剧同步更新，二次元爱好者不可错过的宝藏专区。</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}